import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";
import useUserStore from "@/stores/user";

export default defineStore("agent", () => {
  const agent = ref(null);
  const loadingAgent = ref(false);
  const userStore = useUserStore();
  const { vendorKey } = storeToRefs(userStore);

  async function getAgent(alias) {
    loadingAgent.value = true;
    try {
      const response = await fetch(
        `/api/cmp/${vendorKey.value}/agents/${alias}/`,
      );

      if (!response.ok) {
        throw new Error("Failed to get agent data");
      }

      agent.value = await response.json();
    } finally {
      loadingAgent.value = false;
    }
  }

  return {
    agent,
    loadingAgent,
    getAgent,
  };
});
